import React, {useEffect} from "react"
import { useTranslation } from 'react-i18next';
import Checkbox from '@mui/material/Checkbox';
import {useNavigate} from "react-router-dom";
import AppButton from "app/components/shared/AppButton/AppButton.tsx"
import {ButtonTypeEnum, ButtonSizeEnum, ButtonColorEnum} from "app/components/shared/enums/global-enums.tsx"

import Box from '@mui/material/Box';

import cssVars from 'app/helpers/_variables.module.scss';
import useStore from 'app/store/store';
import "./KnowledgeComponents.scss"

export default function KnowledgeComponents({course}){

  const {t} = useTranslation();
  const navigate = useNavigate();

  const storeActions = useStore((state) => state.actions);

  
  const knowledgeComponents = useStore((state) => state.knowledgeComponents);

  function saveComponents() {
    // console.log(course.knowledge_comp_step);
    let values = {...course};
    values.knowledge_comp_step = false;
    storeActions.updateOrCreateCourse({course: values}, false, window.location.reload());
    // 
  }

  useEffect(() => {
    storeActions.setNavigate(navigate);
    storeActions.fetchKnowledgeComponents({courseId: course.id});
  }, [course, storeActions, navigate]);


  return (
    <Box className="w-100">
      <Box className="center-text " >
        <div className="v-space-5"></div>
        <div className="kc-title">{t("knowledge COMPONENTS")}</div>
        <div className="kc-subtitle">{t("Confirm the components of knowledge relevant for this course")}</div>
        <div className="gray-color">{t("In this course students will learn")}</div>
      </Box>

      <div className="v-space-5"></div>

      <Box className="kc-container">
      {
        knowledgeComponents.map((elm, key)=>{
         return(
          <div key={key} className="fourth-color kc-child" >
            <Checkbox className={'ch-fourth'} label="Label" color="default" checked={true}   />   {elm.title}
          </div>
         ) 
        })
      }
      </Box>

      <Box className="center-text">
        <AppButton 
         buttonType={ButtonTypeEnum.TEXT_OUTLINE}
         buttonColor={ButtonColorEnum.FOURTH}
         buttonLabel={t("+ Add Knowledge")}
         buttonSize={ButtonSizeEnum.SMALL}
         actionType="button"
         />
      </Box>

      <div className="v-space-3"></div>
      
      <Box className="center-text">
        <AppButton 
          onClickFunc={saveComponents}
          sx={{backgroundColor: cssVars['fourth-color']}}
          buttonType={ButtonTypeEnum.SECONDARY}
          buttonLabel={t("Done!")}
          buttonSize={ButtonSizeEnum.SMALL}
          actionType="button"
         />
      </Box>
    </Box>
  );

}